import { db } from '.';

const systemSettingsRef = db.collection('settings').doc('notifications');

async function getSettingFromDB() {
  const snapshot = await systemSettingsRef.get();
  return snapshot.exists
    ? snapshot.data()
    : (await systemSettingsRef.set({})) && {};
}

export default {
  get: getSettingFromDB,
  update: (...args) => systemSettingsRef.update(...args)
};
